import React from "react"

import { AnimateWrapper } from "@components/main/animate-wrapper/AnimateWrapper"
import RecommendedGallery from "@components/main/shopify-gallery/RecommendedGallery"

import * as s from "./NoChristmasProductsList.module.scss"

export const NoChristmasProductsList = () => {
  return (
    <div className={s.ProductsList}>
      <h4>
        The range is currently not available but keep an eye out for
        announcements.
      </h4>
    </div>
  )
}
